<template>
  <article
    class="relative flex h-full flex-col justify-center overflow-hidden rounded-xl border bg-white p-5 text-center transition-shadow hover:shadow sm:p-6 sm:pb-8"
    :class="featured ? 'border-2 border-heroblue-600 bg-ice-50' : 'border-charcoal-200'"
  >
    <div
      v-if="featured"
      class="absolute right-0 top-0 rounded-bl-xl bg-heroblue-600 px-4 py-1 text-xs font-bold uppercase text-white"
    >
      Best Value
    </div>

    <div class="mx-auto flex w-full max-w-lg flex-1 flex-col">
      <div class="flex flex-1 flex-col items-center justify-center gap-3 pt-1">
        <p class="mb-2 text-sm font-bold uppercase text-heroblue sm:text-base">
          {{ category }}
        </p>

        <h3 class="text-xl font-bold text-charcoal-600 sm:text-2xl">
          {{ title }}
        </h3>

        <div>
          <core-price-display
            class="text-2xl sm:text-3xl"
            :show-suffix="false"
            :base-price="product.price_cents"
            :discounted-price="product.promotionPrice"
            smaller-discount
          />
          <span v-if="suffix" class="text-base text-charcoal-400">{{ suffix }}</span>
        </div>
      </div>

      <u-button
        color="heroblue"
        size="lg"
        block
        class="mt-5 justify-center"
        :label="ctaLabel"
        :loading="loading"
        :disabled="loading"
        @click="emit('cta', product)"
      />

      <div class="flex flex-1 items-start justify-center pt-4">
        <p class="text-xs font-semibold uppercase text-charcoal-400">
          {{ description }}
        </p>
      </div>
    </div>
  </article>
</template>

<script setup>
  defineProps({
    product: {
      type: Object,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    suffix: String,
    description: String,
    featured: Boolean,
    loading: Boolean,
    ctaLabel: {
      type: String,
      default: 'Buy Now'
    }
  });

  const emit = defineEmits(['cta']);
</script>
